/* Renders a list of access roles by station
- If null, everyone can see
- If "names" are defined, only those names can see
- If "roles" are defined, users with those roles can see
- If both "names" and "roles" are defined, user must be in either list
*/

export const accessByStation = [{
	station: 0,
	names: null,
	roles: ["pdi"]
}, {
	station: 1,
	names: ["Kevin Mack"],
	roles: ["pdi"]
}, {
	station: 2,
	names: null,
	roles: ["pdi"]
}, {
	station: 3,
	names: null,
	roles: ["pdi"]
}, {
	station: 4,
	names: null,
	roles: ["pdi"]
}, {
	station: 5,
	names: null,
	roles: ["pdi"]
}, {
	station: 6,
	names: null,
	roles: ["pdi"]
}, {
	station: 7,
	names: null,
	roles: ["pdi"]
}, {
	station: 8,
	names: null,
	roles: ["pdi"]
}, {
	station: 9,
	names: null,
	roles: ["pdi"]
}, {
	station: 10,
	names: null,
	roles: ["pdi"]
}, {
	station: 100,
	names: ["Kevin Mack", "Jarvis Hunt", "Matt Olds", "Krystal Ubaldo", "Madelyn George", "Madelyn Forge"],
	roles: null
}]

/*
- Roles:
- admin: full access (view everything, edit everything and override all accessByStation restrictions)
- pdi: access to everything EXCEPT stations with specific names lists (where they're not listed)
  Example: If station 100 has names: ["Kevin Mack"], PDI users NOT in that list cannot see it
*/


export const accessRoles = [
	{ role: "admin", names: ["Curtis Campbell", "Brian Carmichael", "Jimmy Conroy", "Brett Eldridge", "Lucas Eyerman", "Jim Ford", "Jarvis Hunt", "Kevin Mack", "Anyta McVeigh", "Chris Moyer", "Mike Moyer", "Madelyn George", "Madelyn Forge", "Matt Olds", "John Owen", "Krystal Ubaldo", "Matt Whitslar", "Kev Schwartz"] },
	{ role: "pdi", names: ["Tre Hollins", "Flock External", "Collin Adams", "Parker Albert", "Kayla Ault", "Mike Battles", "Philip Bauer", "Hunter Beard", "Zach Blendick", "JJ Briggs", "Curtis Campbell", "Brian Carmichael", "Bruce Carmichael", "Joe Cashetta", "Yon Chong", "Jimmy Conroy", "Bianca Daniels", "Flex Security Deployments", "Scott Dunifon", "Cam Earl", "Brett Eldridge", "Lucas Eyerman", "Jim Ford", "Andy Galindo", "Madelyn George", "Madelyn Forge", "Grant Gillis", "Norma Gutierrez", "Rick Haifley", "Steve Holt", "Alan Honeychurch", "Tyler Host", "Heber Howard", "Jarvis Hunt", "Brian Inacay", "Kevin Mack", "Tessa Mannarino", "RVMP Marketing", "Bartolo Marquez", "Anyta McVeigh", "Chris Moyer", "Mike Moyer", "Scott Moyer", "Israel Nieves", "Chris O'Connor", "Matt Olds", "John Owen", "Rob Queen", "Nick Ruppe", "Admin RVMP", "Service RVMP", "Lisa Schmidtke", "Kev Schwartz", "Flex Security", "Todd Smith", "Andy Stiebler", "Flex Security Support", "RVMP Support", "Krystal Ubaldo", "RVMP Warehouse", "Matt Whitslar", "Matthew Bachman", "Ethan Rubio", "Kim Vaughn"] },
]



// === BEGIN TESTS ===

// Admin = sees everything plus final sign off

// export const accessByStation = [{
// 	station: 0,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 1,
// 	names: ["Kevin Mack"],
// 	roles: ["pdi"]
// }, {
// 	station: 2,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 3,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 4,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 5,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 6,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 7,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 8,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 9,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 10,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 100,
// 	names: ["Kevin Mack"],
// 	roles: null
// }]

// export const accessRoles = [
// 	{ role: "admin", names: ["Kevin Mack", "Kev Schwartz"] },
// 	{ role: "pdi", names: ["Kevin Mack", "Mason Oiler", "Lucas Eyerman"] },
// ]

//  ===========================

// pdi access = sees everything EXCEPT station 100 (final sign off)

// export const accessByStation = [{
// 	station: 0,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 1,
// 	names: ["Kevin Mack"],
// 	roles: ["pdi"]
// }, {
// 	station: 2,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 3,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 4,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 5,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 6,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 7,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 8,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 9,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 10,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 100,
// 	names: ["Kevin Mack"],
// 	roles: null
// }]

// export const accessRoles = [
// 	{ role: "admin", names: ["Kevin Mack"] },
// 	{ role: "pdi", names: ["Kevin Mack", "Mason Oiler", "Lucas Eyerman", "Kev Schwartz"] },
// ]

//  ===========================

// No access restrictions - everyone can see everything

// export const accessByStation = [{
// 	station: 0,
// 	names: null,
// 	roles: null
// }, {
// 	station: 1,
// 	names: null,
// 	roles: null
// }, {
// 	station: 2,
// 	names: null,
// 	roles: null
// }, {
// 	station: 3,
// 	names: null,
// 	roles: null
// }, {
// 	station: 4,
// 	names: null,
// 	roles: null
// }, {
// 	station: 5,
// 	names: null,
// 	roles: null
// }, {
// 	station: 6,
// 	names: null,
// 	roles: null
// }, {
// 	station: 7,
// 	names: null,
// 	roles: null
// }, {
// 	station: 8,
// 	names: null,
// 	roles: null
// }, {
// 	station: 9,
// 	names: null,
// 	roles: null
// }, {
// 	station: 10,
// 	names: null,
// 	roles: null
// }, {
// 	station: 100,
// 	names: null,
// 	roles: null
// }]

// export const accessRoles = [
// 	{ role: "admin", names: ["Kevin Mack"] },
// 	{ role: "pdi", names: ["Kevin Mack", "Mason Oiler", "Lucas Eyerman", "Kev Schwartz"] },
// ]


//  ===========================

// Specific station access
//Kev Schwartz only has access to station 2. Can see station 0 because it's open for all to see.

// export const accessByStation = [{
// 	station: 0,
// 	names: null,
// 	roles: null
// }, {
// 	station: 1,
// 	names: ["Kevin Mack"],
// 	roles: ["pdi"]
// }, {
// 	station: 2,
// 	names: ["Kev Schwartz"],
// 	roles: ["pdi"]
// }, {
// 	station: 3,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 4,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 5,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 6,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 7,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 8,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 9,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 10,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 100,
// 	names: ["Kevin Mack"],
// 	roles: null
// }]

// export const accessRoles = [
// 	{ role: "admin", names: ["Kevin Mack"] },
// 	{ role: "pdi", names: ["Kevin Mack", "Mason Oiler", "Lucas Eyerman"] },
// ]


// //  ===========================

// // Unit sign off user only - Kev Schwartz can only see station 100 (final sign off) and station 0 (open to all)

// export const accessByStation = [{
// 	station: 0,
// 	names: null,
// 	roles: null
// }, {
// 	station: 1,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 2,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 3,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 4,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 5,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 6,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 7,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 8,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 9,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 10,
// 	names: null,
// 	roles: ["pdi"]
// }, {
// 	station: 100,
// 	names: ["Kev Schwartz"],
// 	roles: null
// }]

// export const accessRoles = [
// 	{ role: "admin", names: ["Kevin Mack"] },
// 	{ role: "pdi", names: ["Kevin Mack", "Mason Oiler", "Lucas Eyerman"] },
// ]

//  ==========================
